// Simulador de ubicacion ficticia para probar TKT-2149 desde el navegador (SOLO dev).
//
// En web el navegador no reporta si la posicion es simulada (isMock queda null) y el guard de
// geolocalizacion se salta por completo. Con el simulador activo, la app se comporta como en el
// celular: el guard corre y la posicion trae la bandera isMock que se le indique. Asi se prueba
// bloqueo -> registro del log -> notificacion -> Excel contra el back local sin compilar un APK.
//
// Se enciende con MOCK_SIMULATOR=1 en el .env (y reiniciar `quasar dev`). Uso desde la consola
// del navegador:
//   binnacleMock('mocked')  // la posicion llega como simulada (bloquea si la politica es block)
//   binnacleMock('clean')   // la posicion llega como real (no bloquea)
//   binnacleMock('off')     // apaga el simulador: comportamiento normal de web
//   binnacleMock()          // estado actual
//   binnacleMock('clean', { lat: 19.4326, lng: -99.1332 })  // ademas fija las coordenadas
//
// Con el simulador activo la posicion NO sale del GPS del navegador (en escritorio suele no haber
// o se queda esperando el permiso): se usan coordenadas fijas. Para probar un formulario con
// geocerca en modo 'clean', pasar las coordenadas de la ubicacion.
//
// Fuera de dev (import.meta.env.DEV false) nada de esto se activa aunque la variable venga en 1, y
// el bundle de produccion descarta las ramas.

const STORAGE_KEY = 'binnacle:mock-simulator'
const COORDS_KEY = 'binnacle:mock-simulator-coords'
const MODES = ['mocked', 'clean']
// Centro de la CDMX: solo para que haya una coordenada valida si no se configuro otra.
const DEFAULT_COORDS = { lat: 19.4326, lng: -99.1332 }

// Dev Y la variable del .env: sin ella, aun en dev, el simulador no existe (un `quasar dev`
// apuntando a produccion no puede registrar bloqueos de prueba por accidente).
export function isMockSimulatorEnabled () {
  return import.meta.env.DEV === true && import.meta.env.MOCK_SIMULATOR === '1'
}

function readMode () {
  try {
    const mode = globalThis.localStorage?.getItem(STORAGE_KEY)

    return MODES.includes(mode) ? mode : null
  } catch {
    return null
  }
}

export function isMockSimulatorActive () {
  return isMockSimulatorEnabled() && readMode() !== null
}

// true / false segun el modo; null si el simulador esta apagado (mismo valor que web normal).
function simulatedIsMock () {
  if (!isMockSimulatorEnabled()) return null

  const mode = readMode()

  return mode === null ? null : mode === 'mocked'
}

function readCoords () {
  try {
    const coords = JSON.parse(globalThis.localStorage?.getItem(COORDS_KEY) || 'null')

    return Number.isFinite(coords?.lat) && Number.isFinite(coords?.lng) ? coords : DEFAULT_COORDS
  } catch {
    return DEFAULT_COORDS
  }
}

// Posicion con la misma forma que readNativePosition; null si el simulador esta apagado.
export function simulatedPosition () {
  const isMock = simulatedIsMock()
  if (isMock === null) return null

  const { lat, lng } = readCoords()

  return {
    coords: { latitude: lat, longitude: lng, accuracy: 10, altitude: null },
    timestamp: Date.now(),
    isMock,
    provider: 'simulator'
  }
}

function status () {
  const mode = readMode()

  return mode === null ? 'off' : { mode, ...readCoords() }
}

function setMode (mode, coords) {
  if (mode === undefined) return status()

  try {
    if (MODES.includes(mode)) globalThis.localStorage.setItem(STORAGE_KEY, mode)
    else globalThis.localStorage.removeItem(STORAGE_KEY)

    if (coords) globalThis.localStorage.setItem(COORDS_KEY, JSON.stringify({ lat: Number(coords.lat), lng: Number(coords.lng) }))
  } catch (error) {
    console.error('[mock-simulator] no se pudo guardar el modo', error)
  }

  return status()
}

export function installMockSimulator () {
  if (!isMockSimulatorEnabled() || typeof window === 'undefined') return

  window.binnacleMock = setMode
}
